import { Cart } from '@peerless/data-access/cart-service/server';
import fetcher from '../client';

export const updateCart = (sku: string, quantity: number, locale: string): Promise<Cart> => {
  return fetcher.post(`/cart/update?locale=${locale}`, { sku, quantity });
};
